import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StoreProvider } from './lib/store'
import App from './App'
import { markRenderMode } from './app/render-mode'

/* `data-app="v2"` é o escopo do CSS do produto: tokens, fundações e primitivas
 * todos pendem dele. Ele é ligado aqui, uma vez, e nunca sai — quando cada
 * superfície o ligava por conta própria, a espera da sessão renderizava antes
 * de todas elas e ficava sem token nenhum. */
document.documentElement.setAttribute('data-app', 'v2')

const queryClient = new QueryClient({ defaultOptions: { queries: { staleTime: 30_000, refetchOnWindowFocus: false } } })
markRenderMode()

createRoot(document.getElementById('root')!).render(
  <StrictMode><QueryClientProvider client={queryClient}><BrowserRouter><StoreProvider><App /></StoreProvider></BrowserRouter></QueryClientProvider></StrictMode>
)
